import type { ItemRowEdge, MailboxInfo, ItemRow } from "owa-graph-schema";
import { mapOwsItemToGqlItemRow } from "../mapOwsItemToGqlItemRow";
import type { MessageTableType } from "owa-offline-messages-schema";
import type Item from "owa-service/lib/contract/Item";

export function getStartCursor(items?: any[]): string {
    if (items && items.length > 0) {
        return items[0].InstanceKey ?? "";
    }
    
    return "";
}

export function getEndCursor(items?: any[]): string {
    if (items && items.length > 0) {
        return items[items.length - 1].InstanceKey ?? "";
    }
    
    return "";
}

export function getEdges(mailboxInfo: MailboxInfo, items?: MessageTableType[] | Item[]): ItemRowEdge[] {
    if (!items || items.length == 0) {
        return [];
    }
    
    return items.map(item => {
        return {
            __typename: "ItemRowEdge",
            cursor: item.InstanceKey ?? "",
            node: isMessageTableType(item)
                ? (item as ItemRow)
                : mapOwsItemToGqlItemRow(item, mailboxInfo),
        } as ItemRowEdge;
    });
}

function isMessageTableType(message: MessageTableType | Item): message is MessageTableType {
    return (message as MessageTableType).MetaData !== undefined;
}
